import Colors from '@root/brand/src/utils/colors';
import LoginEmailPassword from '@root/login/src/components/login-email-password';
import LoginEmailPasswordHeading from '@root/login/src/components/login-email-password-heading';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import RouteLink from '@root/core/src/components/route-link';
import environment from '@root/core/src/utils/environment';
import useAnalytics from '@root/core/src/hooks/use-analytics';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

export default function LoginWithEmailPassword({
  module, passProps, basePath,
}) {
  const analytics = useAnalytics([module, 'LOGIN_PASSWORD']);

  const handleSignup = () => {
    analytics.trackClick('SIGN_UP');
    passProps.onLogout && passProps.onLogout();
  };

  const handleForgotPassword = () => {
    analytics.trackClick('FORGOT_PASSWORD');
    passProps.onLogout && passProps.onLogout();
  };

  const renderRecaptchaPrivacyPolicyLink = () => (
    <a
      css={styles.disclaimerLink}
      href={'https://policies.google.com/privacy'}
      rel={'noopener noreferrer'}
      target={'_blank'}
    >
      Privacy Policy
    </a>
  );

  const renderRecaptchaTermsOfServiceLink = () => (
    <a
      css={styles.disclaimerLink}
      href={'https://policies.google.com/terms'}
      rel={'noopener noreferrer'}
      target={'_blank'}
    >
      Terms of Service
    </a>
  );

  return (
    <div css={styles.outerContainer}>
      <div css={styles.innerContainer}>
        <LoginEmailPasswordHeading
          heading={'Sign in to your Root account.'}
          subtext={'View your policy, manage your payment methods, and more.'}
        />
        <LoginEmailPassword
          analytics={analytics}
          onLogin={passProps.onLogin}
        />
        <div css={styles.linksContainer}>
          <div css={styles.linkContainer}>
            <RouteLink
              css={styles.link}
              onClick={handleForgotPassword}
              to={`${basePath}/password-reset`}
            >
              Forgot password?
            </RouteLink>
          </div>
          <div css={styles.linkContainer}>
            {'New to Root? '}
            <a
              css={styles.link}
              href={`https://${environment.quoteAppDomain}`}
              onClick={handleSignup}
            >
              Sign up
            </a>
          </div>
          <br />
          <div>
            <p css={styles.disclaimerText}>
              This site is protected by reCAPTCHA and the Google {renderRecaptchaPrivacyPolicyLink()} and {renderRecaptchaTermsOfServiceLink()} apply
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  outerContainer: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  innerContainer: {
    display: 'flex',
    maxWidth: '380px',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  linksContainer: {
    marginTop: '10px',
  },
  linkContainer: {
    ...Theme.paragraph1({
      bold: true,
    }),
    textAlign: 'center',
    marginTop: '30px',
  },
  link: {
    ...Theme.boldLink(),
  },
  disclaimerLink: {
    color: Colors.gray50(),
    cursor: 'pointer',
    fontSize: '12px',
    textDecoration: 'underline',
    ':hover': {
      textDecoration: 'underline',
      color: Colors.gray40(),
    },
  },
  disclaimerText: {
    fontSize: '12px',
    textAlign: 'center',
  },
});

LoginWithEmailPassword.propTypes = {
  basePath: PropTypes.string.isRequired,
  module: PropTypes.string.isRequired,
  passProps: PropTypes.object.isRequired,
};
